import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Grid, Button } from 'semantic-ui-react';

import { Filter, Main } from 'Containers';
import ReactTable from 'Common/ReactTableWrapper';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import * as VendingActions from './state/actions';
import * as VendingSelectors from './state/selectors';
import { VendingMachineFieldEnum } from 'Common/FieldEnum';
import { VendingMachineEntryModal } from './components/VendingMachineEntryModal';
import { errorToast } from 'Common/ToastHelper';
import { NotificationMessage, YesNoDialog } from 'Components/';

const humanName = 'Vending Machine';

class VendingSetupContainer extends Component {
  state = {
    rowData: undefined,
    isCreateModalOpen: false,
    isDeleteModalOpen: false,
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: rowData => this.openCreateModal(rowData),
      disabledWhen: x => this.props.isReadOnly,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: rowData => this.openDeleteModal(rowData),
      disabledWhen: x => this.props.isReadOnly,
    },
  ];

  columns = [
    {
      Header: 'Name',
      accessor: VendingMachineFieldEnum.Name,
      filterable: false,
      resizable: false,
      Cell: props => {
        return `VM_${props.value}`;
      },
    },
    {
      Header: 'Description',
      accessor: VendingMachineFieldEnum.Description,
      filterable: false,
      resizable: false,
    },
    {
      Header: 'Site',
      accessor: VendingMachineFieldEnum.SiteDescription,
      filterable: false,
      resizable: false,
    },
    {
      Header: 'Vending Machine ID',
      minWidth: 150,
      accessor: VendingMachineFieldEnum.MachineId,
      filterable: false,
      resizable: true,
    },
    {
      Header: '',
      id: 'menu',
      width: 50,
      sortable: false,
      resizable: false,
      style: { textAlign: 'center' },
      Cell: gridProps =>
        GridContextMenu({ gridProps, options: this.menuOptions }),
    },
  ];

  componentDidMount() {
    const { getVendingMachines } = this.props;

    getVendingMachines();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      postVendingMachineResult,
      postVendingMachineErrors,
      clearPostVendingMachineResult,

      postDeleteVendingMachineResult,
      postDeleteVendingMachineErrors,
      clearPostDeleteVendingMachineResult,
    } = this.props;

    if (postVendingMachineResult || postVendingMachineErrors) {
      if (!errorToast(this.props, prevProps, 'postVendingMachineErrors')) {
        NotificationMessage({ Data: postVendingMachineResult, Errors: [] });
        this.closeCreateModal();
      }

      clearPostVendingMachineResult();
    }

    if (postDeleteVendingMachineResult || postDeleteVendingMachineErrors) {
      if (
        !errorToast(this.props, prevProps, 'postDeleteVendingMachineErrors')
      ) {
        NotificationMessage({
          Data: postDeleteVendingMachineResult,
          Errors: [],
        });
        this.closeDeleteModal();
      }

      clearPostDeleteVendingMachineResult();
    }
  }

  openCreateModal = (row = {}) => {
    this.setState({ rowData: row, isCreateModalOpen: true });
  };

  closeCreateModal = () => this.setState({ isCreateModalOpen: false });

  openDeleteModal = row => {
    if (!row) {
      return;
    }

    this.setState({ rowData: row, isDeleteModalOpen: true });
  };

  closeDeleteModal = () => this.setState({ isDeleteModalOpen: false });

  /** submit a new row, and on success, and it to the table */
  handleSubmit = rowData => this.props.postVendingMachine(rowData);

  /** delete a row */
  handleDelete = rowData =>
    this.props.postDeleteVendingMachine(rowData[VendingMachineFieldEnum.Id]);

  render() {
    const {
      isReadOnly,
      getVendingMachinesResult,
      getVendingMachinesLoading,
    } = this.props;

    const { rowData, isCreateModalOpen, isDeleteModalOpen } = this.state;

    return (
      <Fragment>
        <Filter title={'Vending Setup'}>
          <Grid>
            <Grid.Row>
              <Grid.Column floated="right" textAlign="right">
                <Button
                  content={`Add ${humanName}`}
                  onClick={() => this.openCreateModal()}
                  disabled={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>

        <Main>
          <ReactTable
            data={getVendingMachinesResult || []}
            className="-striped -highlight grid--fixed-row-height"
            loading={getVendingMachinesLoading}
            columns={this.columns}
            menu="hasCogs"
            minRows={5}
            noDataText="No rows found"
          />

          <VendingMachineEntryModal
            rowData={rowData}
            isOpen={isCreateModalOpen}
            onClose={this.closeCreateModal}
            onSubmit={this.handleSubmit}
          />

          <YesNoDialog
            showDialog={isDeleteModalOpen}
            title={`Delete ${humanName}`}
            question={`Are you sure you want to delete this ${humanName}: ${rowData &&
              rowData.Name}?`}
            yesCallback={() => this.handleDelete(rowData)}
            noCallback={() => this.closeDeleteModal()}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    getVendingMachinesLoading: VendingSelectors.getVendingMachinesLoading(
      state
    ),
    getVendingMachinesResult: VendingSelectors.getVendingMachinesResult(state),

    postVendingMachineLoading: VendingSelectors.postVendingMachineLoading(
      state
    ),
    postVendingMachineResult: VendingSelectors.postVendingMachineResult(state),
    postVendingMachineErrors: VendingSelectors.postVendingMachineErrors(state),

    postDeleteVendingMachineResult: VendingSelectors.postDeleteVendingMachineResult(
      state
    ),
    postDeleteVendingMachineErrors: VendingSelectors.postDeleteVendingMachineErrors(
      state
    ),
  };
};

const mapDispatchToProps = {
  getVendingMachines: VendingActions.getVendingMachines,

  postVendingMachine: VendingActions.postVendingMachine,
  clearPostVendingMachineResult: VendingActions.clearPostVendingMachineResult,

  postDeleteVendingMachine: VendingActions.postDeleteVendingMachine,
  clearPostDeleteVendingMachineResult:
    VendingActions.clearPostDeleteVendingMachineResult,
};

export const VendingSetup = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendingSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/vendingsetup/VendingSetup.js